"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpFooter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var Footer_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Footer/Footer.component");
var Link_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Link/Link.component");
var ThemeWrapper_component_1 = require("@greatmindsorg/gmui-lib/dist/components/ThemeWrapper/ThemeWrapper.component");
var ArrowUpRightFromSquare_1 = __importDefault(require("@greatmindsorg/gmui-icons-lib/dist/ArrowUpRightFromSquare"));
var DpFooter_styled_1 = require("./DpFooter.styled");
var links = [
    {
        href: 'https://greatminds.org/privacy-policy',
        text: 'Privacy Policy',
    },
    {
        href: 'https://greatminds.org/legal/terms-of-service',
        text: 'Terms Of Service',
    },
    {
        href: 'https://legal.greatminds.org',
        text: 'Credits',
    },
    {
        href: 'https://digitalsupport.greatminds.org/s/',
        text: 'Help Center',
    },
    {
        href: 'https://greatminds.org/privacy-options',
        text: 'CA Residents: do not sell my info',
    },
];
var linkStyle = 'flex items-center gap-x-3xs whitespace-nowrap';
var DpFooter = function () { return (
// -------------- Render
(0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsx)(ThemeWrapper_component_1.ThemeWrapper, { as: "main", children: (0, jsx_runtime_1.jsx)(DpFooter_styled_1.StyledFooter, { children: (0, jsx_runtime_1.jsx)(Footer_component_1.Footer, { id: "gmuiFooter", "aria-label": "footer", children: links.map(function (_a) {
                    var href = _a.href, text = _a.text;
                    return ((0, jsx_runtime_1.jsx)(Link_component_1.Link, { className: linkStyle, icon: (0, jsx_runtime_1.jsx)(ArrowUpRightFromSquare_1.default, { title: "Opens in new tab", iconSize: "inherit" }), iconPosition: "right", href: href, size: "small", target: "_blank", children: text }, href));
                }) }) }) }) })); };
exports.DpFooter = DpFooter;
exports.default = exports.DpFooter;
